import CustomElement from '~utilities/custom-element';
import TabIndexChildren from '~utilities/tab-index-children/index';
import 'url-search-params-polyfill';


const JS_TAB = 'js-tab';
const JS_TAB_LIST = '[js-tab-list]';
const ACTIVE_CLASS = 'is--active';

class Tab extends CustomElement {
    constructor() {
        super();
    }

    callback(element = false) {
        super.callback(element);
        this.tabFocus = 0;
        this.tabList = this.element.querySelector(JS_TAB_LIST);
        this.tabs = [...this.tabList.querySelectorAll('[role="tab"]')];
        this.options();
        this.setAttribute();
        this.bindEvents();
        if(this.url) this.triggerOnUrl();
    }

    bindEvents() {
        this.tabs.forEach(tab => tab.addEventListener("click", (event) => this.changeTabs(tab, event)));
        this.tabList.addEventListener("keydown", event => this.setTabFocus(event));
    }

    options() {
        let attributes = this.element.getAttribute(JS_TAB);
        if(!attributes) return;
        attributes = attributes.split('|');
        
        attributes.forEach(attribute => {
            switch(attribute) {
                case 'url':
                    this.url = true;
                    break;
                case 'scroll':
                    // Empty option, for tabcordion items
                    break;
                default:
                    console.warn(`tab.options(): ${attribute} is not an option.`);
                    break;
            }
        });
    }

    setTabFocus(event) {
        const key = event.code;
        if (key === 'ArrowRight' || key === 'ArrowLeft' || key === 'ArrowUp' || key === 'ArrowDown') {
            this.tabs[this.tabFocus].tabIndex = -1;

            if (key === 'ArrowRight' | key === 'ArrowDown') {
                this.tabFocus++;
                if (this.tabFocus >= this.tabs.length) this.tabFocus = 0;

            }else {
                this.tabFocus--;
                if (this.tabFocus < 0) this.tabFocus = this.tabs.length - 1;
            }

            this.tabs[this.tabFocus].tabIndex = 0;
            this.tabs[this.tabFocus].focus();
        }
    }

    setAttribute() {
        this.tabs.forEach((tab, index) => {
            const id = tab.getAttribute('js-tab-header');
            if(id) {
                const tabPanel = this.element.querySelector(`[js-content='${id}']`);
                tab.id = id;
                tabPanel.setAttribute('role','tabpanel');
                tabPanel.setAttribute('aria-labelledby',`${id}`);
                tabPanel.id = `tab-panel-${id}`;
                tab.setAttribute('aria-controls', `tab-panel-${id}`);
                tab.classList.add('tab__tab');
                const current = tab.getAttribute('aria-selected') === 'true';
    
                this.setPanel(tab, tabPanel, current);
            }
        });
    }

    setPanel(tab, tabPanel, current) {
        const tabIndex = current ? 0 : -1;
        const toggle = current ? 'add' : 'remove';

        tab.tabIndex = tabIndex;
        tab.classList[toggle](ACTIVE_CLASS);
        if(tabPanel){
            tabPanel.classList[toggle](ACTIVE_CLASS);
            new TabIndexChildren(tabPanel, tabIndex, true);
        }

    }

    changeTabs(target, event) {
	    if(!target) event.preventDefault();

        this.tabs.forEach(tab => {
            tab.classList.remove(ACTIVE_CLASS);
            const tabPanel = this.element.querySelector(`[js-content='${tab.getAttribute('js-tab-header')}']`);
            let current = tab === target;

            const toggle = current ? true : false;
            tab.setAttribute("aria-selected", toggle);

            this.setPanel(tab, tabPanel, current);
        });

        if(this.url) {
            this.urlParam.set('tab', target.id);
            window.history.replaceState(null, null, `${window.location.href.split('?')[0]}${this.urlParam.has('tab') ? `?tab=${this.urlParam.get('tab')}` : ''}`);
        }
    }

    triggerOnUrl() {
        this.urlParam = new URLSearchParams(window.location.search);
        
        const tab = this.urlParam.has(`tab`) ? this.urlParam.get(`tab`) : '';
	    
	    if(tab) {
			const triggeredTab = this.element.querySelector(`#${tab}`);
		    if(triggeredTab) triggeredTab.click();
	    }
    }
}

export default Tab;